<template>
  <a-layout class="layout">
    <a-layout-content :class="[{'mobile-style': isMobile, 'pc-style': !isMobile}]">
      <a-breadcrumb style="margin: 16px 0">
      </a-breadcrumb>
      <div :style="{ background: '#fff', padding: '24px', minHeight: '280px' }">
        <a-menu v-model:selectedKeys="current" mode="horizontal" :items="items"/>

        <div class="example" v-show="formLoading">
          <a-spin />
        </div>

        <a-form
            v-show="!formLoading"
            :model="formState"
            name="basic"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 14 }"
            autocomplete="off"
            @finish="onFinish"
            @finishFailed="onFinishFailed"
            :style="{ padding: '40px' }"
        >
          <a-form-item
              label="Code (8 letters on the card)"
              name="code"
              :rules="[{ required: true, message: 'Please input your code!' }]"
          >
            <a-input v-model:value="formState.code" />
          </a-form-item>

          <a-form-item
              label="Order Id (you buy)"
              name="order_id"
              :rules="[{ required: true, message: 'Please input your order id!' }]"
          >
            <a-input v-model:value="formState.order_id" />
          </a-form-item>

          <a-form-item
              label="Contact Email"
              name="email"
              :rules="[{ type: 'email', required: true, message: 'Please enter a valid email address!' }]"
          >
            <a-input v-model:value="formState.email" />
          </a-form-item>

          <a-form-item
              label="Phone"
              name="phone"
          >
            <a-input v-model:value="formState.phone" />
          </a-form-item>

          <a-form-item :name="['imageList']" label="Review Screenshot"
              :rules="[{ required: true, message: 'Review Screenshot is required' }]"
              v-if="formState.process !== '' && formState.process !== 'unverified'"
          >
            <a-upload
                name="file"
                v-model:file-list="fileList"
                :action="apiUrl + '/api/free-review/upload'"
                :before-upload="beforeUpload"
                :headers="uploadHeader"
                list-type="picture-card"
                @preview="handlePreview"
                accept="image/jpeg,image/png,image/jpg,image/gif"
                @change="handleUploadChange"
                style="text-align: left"
            >
              <div v-if="fileList.length < 1">
                <div style="margin-top: 8px">Upload</div>
              </div>
            </a-upload>
            <a-modal :open="previewVisible" :title="previewTitle" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage"/>
            </a-modal>
          </a-form-item>

          <a-form-item
              label="Payment account information"
              name="payment_info"
              :rules="[{ required: true, message: 'Please fill in the payment recipient details.' }]"
              v-if="formState.prize_type === 'CASH' && formState.process !== '' && formState.process !== 'unverified'"
          >
            <a-textarea v-model:value="formState.payment_info" :maxlength="300" :auto-size="{ minRows:5 }" show-count
                placeholder="e.g.&#10;Paypal: xxxxx@xxx.com"/>
          </a-form-item>

          <a-form-item
              label="Delivery address"
              name="address"
              :rules="[{ required: true, message: 'Please enter the delivery address.' }]"
              v-if="formState.prize_type === 'PRODUCT' && formState.process !== '' && formState.process !== 'unverified'"
          >
            <a-textarea v-model:value="formState.address" :maxlength="300" :auto-size="{ minRows:5 }" show-count
                placeholder="Please enter the delivery address"/>
          </a-form-item>

          <a-form-item  :wrapper-col="{ span: 12, offset: 6 }">
            <a-button type="primary" html-type="submit" :loading="loading">
              {{ (formState.process !== '' && formState.process !== 'unverified') ? 'submit' : 'continue' }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center; height: 0px;">
    </a-layout-footer>
  </a-layout>
</template>

<script setup>
/*export default {
  name: "ClaimPrize"
}*/

import {h, ref, reactive, inject, onMounted} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {message} from "ant-design-vue";
import {claimDetail, claimPrize} from "@/services/claimPrize";

const router = useRouter();
const showLogin = inject('showLogin');
const isMobile = inject('isMobile');
showLogin.value = false;

const apiUrl = process.env.VUE_APP_API_URL;
const loading = ref(false);
const formLoading = ref(false);
const current = ref(['claim-prize']);
const authState = inject('authState');
const items = ref([
  {
    key: 'claim-prize',
    label: h(
        'a',
        {
          href: '/claim-prize',
        },
        'Claim Reward'
    ),
    title: 'Claim Reward',
  },
  {
    key: 'claim-history',
    label: h(
        'a',
        {
          href: '/claim-history',
        },
        'Claim History',
    ),
    title: 'Claim History',
  },
]);


function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');
const fileList = ref([]);
const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async file => {
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj);
  }
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
  previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};
const formState = reactive({
  'id': '',
  'code': '',
  'order_id': '',
  'email': authState != null ? authState.email : '',
  'phone': '',
  'imageList': [],
  'payment_info': '',
  'prize_type': '',
  'process': ''
});
const beforeUpload = file => {
  // 1. 检查文件类型（通过 MIME 类型）
  const isImage = file.type.startsWith('image/');
  if (!isImage) {
    message.error('Please upload image format file!');
    return false; // 非图片文件，禁止上传
  }

  // 2. （可选）检查文件扩展名（防止用户篡改扩展名）
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif'];
  const lastDotIndex = file.name.lastIndexOf('.');
  if (lastDotIndex === -1) {
    message.error('Image format error!');
    return false; // 无扩展名
  }
  const ext = file.name.slice(lastDotIndex + 1).toLowerCase();
  if (!allowedExtensions.includes(ext)) {
    message.error('Image format not supported!');
    return false;
  }

  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
    return false;
  }

  return true;
};
const handleUploadChange = async (info) => {
  loading.value = true;

  if (info.file.status === 'done') {
    // 上传成功，获取响应数据
    console.log('接口返回', info.file.response);
    if (info.file.response.code === 200) {
      info.file.url = info.file.response.data.url;
      formState.imageList.push(info.file.response.data.url);
    } else {
      info.file.status = 'error';
      info.file.url = '';
      message.error(info.file.response.msg);

      // 上传失败移除选择的图片
      fileList.value = fileList.value.filter(items => {
        return items.uid !== info.file.uid
      });
    }
  } else if (info.file.status === 'error') {
    // 上传失败，获取错误信息
    console.error('上传失败', info.file.error);
    message.error('Upload error');
  } else if (info.file.status === 'removed') {
    fileList.value = fileList.value.filter(items => {
      return items.uid !== info.file.uid
    });
    flushImageList();
  }
  console.log('=====最新 fileList', fileList.value)
  loading.value = false;
};
const uploadHeader = {
  'Authorization': authState != null ? authState.token : '',
};
// 提交表单
const onFinish = async values => {
  console.log('提交===')
  loading.value = true;

  // 获取图片链接
  flushImageList();
  const res = await claimPrize(formState);
  console.log('=====图片提交结果', res);
  if (typeof res !== 'undefined' && res.code === 200) {
    formState.prize_type = res.data.prize_type;
    formState.process = res.data.process;
    // await router.push('/claim-history');
    // 判断 process 状态，如果是空或者是未验证，则留在当前页面，反之跳转到领奖列表页 formState.process === '' || formState.process === 'unverified'
    console.log('---111111---');
    console.log(res);
    console.log('---222222---');
    console.log(formState);
    if (res.data.process === 'submitted' || res.data.process === 'unverified') {
      await router.push('/claim-history');
    }
  }
  loading.value = false;
};
function flushImageList() {
  formState.imageList = [];
  fileList.value.forEach(item => {
    formState.imageList.push(item.url)
  });
}
const onFinishFailed = errorInfo => {
  console.log('Failed:', errorInfo);
};


// 页面加载完调用接口
onMounted(async () => {
  const route = useRoute();
  const id = route.query.id;
  console.log('===claim-prize', id);
  console.log(route);
  if (typeof id !== 'undefined' && id !== null && id !== '') {
    formLoading.value = true;
    await queryData({record_id: id});
  }
});

const queryData = async params => {
  console.log('===params', params)
  const res = await claimDetail(params);
  console.log('===query res', res);
  if (typeof res !== 'undefined' && res.code === 200) {

    formState.code = res.data.code;
    formState.prize_type = res.data.prize_type;
    formState.order_id = res.data.order_id;
    formState.email = res.data.email;
    formState.phone = res.data.phone;
    formState.imageList = res.data.screenshot;
    formState.payment_info = res.data.payment_info;
    formState.prize_claim_time = res.data.prize_claim_time;
    formState.process = res.data.process;
    formState.address = res.data.address;

    if (Array.isArray(formState.imageList) && formState.imageList.length > 0) {
      let _index = 0;
      formState.imageList.forEach(item => {
        _index++;
        fileList.value.push({
          uid: _index,
          name: 'image: ' + _index,
          status: 'done',
          url: item
        })
      });
    }
  } else {
    message.error(res.msg);
  }

  formLoading.value = false;

  return res;
};
</script>

<style scoped>
/** form 表单自适应移动端 **/
.responsive-form {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .responsive-form {
    padding: 10px;
  }
  /* 手机端调整表单元素间距 */
  :deep(.ant-form-item) {
    margin-bottom: 16px;
  }
  /* 调整输入框大小 */
  :deep(.ant-input),
  :deep(.ant-input-password) {
    font-size: 16px; /* 手机端增大字体 */
  }
}
/* 全局表单响应式调整 */
:deep(.ant-form-vertical .ant-form-item-label) {
  padding-bottom: 8px !important;
}
</style>
